import * as Sentry from '@sentry/react';

const DSN = process.env.REACT_APP_SENTRY_DSN || '';
const ENV = process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV || 'development';

let _initialized = false;

const init = () => {
  if (_initialized || !DSN) return;
  Sentry.init({
    dsn: DSN,
    environment: ENV,
    tracesSampleRate: 0.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 0.0,
  });
  _initialized = true;
};

const captureException = (err, context) => {
  if (!_initialized) return;
  Sentry.captureException(err, context ? { extra: context } : undefined);
};

const captureMessage = (message, context) => {
  if (!_initialized) return;
  Sentry.captureMessage(message, context ? { extra: context } : undefined);
};

const sentry = {
  init,
  captureException,
  captureMessage,
};

export default sentry;
